import { atom } from 'recoil';
import { logOnSet } from '../effects';

export const isOnlineState = atom({
  key: 'networkStatus.isOnline',
  default: true,
  effects: [logOnSet],
});
